import { render } from "./batch-apply.vue?vue&type=template&id=f88fafc2&scoped=true"
import script from "./batch-apply.vue?vue&type=script&lang=js"
export * from "./batch-apply.vue?vue&type=script&lang=js"

import "./batch-apply.vue?vue&type=style&index=0&id=f88fafc2&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f88fafc2"]])

export default __exports__